import React from 'react';
import { WizardContentCardType } from '../../screen';
import isNull from 'lodash/isNull';
import { Content } from 'src/common/interfaces/content.interface';
import { WizardContentListLibraryCard } from './library';
import { WizardContentListCardFile } from './file';

const placeholderCardClasses =
  'flex flex-shrink-0 items-center min-h-[56px] justify-center border-2 border-dashed border-bedrock-medium-gray h-[53px] w-full rounded-lg';

export const WizardContentListCardFactory = (
  stack: WizardContentCardType,
  { onDeleteClick }: { onDeleteClick: () => void }
) => {
  if (!stack || isNull(stack)) {
    return () => <div className={placeholderCardClasses} />;
  }

  if (['existing_content', 'url'].includes(stack.type)) {
    const content = stack.content as Content;
    return () => <WizardContentListLibraryCard content={content} onDeleteClick={onDeleteClick} />;
  }

  if (stack.type === 'file') {
    const file = stack.content as File;
    return () => <WizardContentListCardFile file={file} meta={stack.meta} onDeleteClick={onDeleteClick} />;
  }

  return () => null;
};
